<template>
    <div class="row">
        <div class="col-md-4">
            <div class="form-group">
                <select v-model="country" class="form-control" id="dealers" v-on:change="onChange">
                    <option value="">Select region</option>
                    <option v-for= "(region,index) in regions" :value="region.id">{{ region.country }}</option>
                </select>
            </div>
            <ul class="list-group">
              <li v-for="dealer in dealers" class="list-group-item dealer" :marker="dealer.google_lat_lng" @click="updateMarker">
                {{ dealer.name }}<br/>
                {{ dealer.street_address }}<br/>
                {{ dealer.zip }} {{ dealer.city }}<br/>
                contact: {{ dealer.contact_person }}<br/>
                phone: {{ dealer.telephone }}<br/>
                email: {{ dealer.email }}<br/>
                web: {{ dealer.url }}
              </li>
            </ul>
        </div>
        <div class="col-md-8">
            <gmap-map
                :center="center"
                :zoom="zoom"
                style="width:100%;  height: 400px;"
            >
                <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
                ></gmap-marker>
            </gmap-map>
        </div>
    </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      center: { lat: 46, lng: 14 },
      zoom: 5,
      markers: [],
      country: '',
    };
  },
  props: {
    regions: Array,
    dealers: Array,
  },
  mounted() {
    this.geolocate();
  },

  methods: {
    onChange: function() {
      window.axios.get('/api/dealers/'+this.country)
      .then((response)=>{
        this.dealers = response.data.dealers;
      });
    },
    updateMarker(e) {
      var lat_lng = e.currentTarget.getAttribute('marker');
      var marker_data = lat_lng.split(',');
      if(marker_data.length = 2) {
        const marker = {
          lat: parseFloat(marker_data[0].trim()),
          lng: parseFloat(marker_data[1].trim()),
        };
        this.markers = [];
        this.markers.push({ position: marker });
        this.zoom = 14;
        this.center = marker;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
  }
};
</script>